export const state = {
  userInfo: null,
  jwt: null,
  userIsLoggedIn: false
}

export default state



// WEBPACK FOOTER //
// ./src/store/module/auth/state.js